(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hv-coverage-opt-in"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hv-coverage-opt-in')) {
  customElements.define('hv-coverage-opt-in', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const root = this.closest('product-info');
      if (!root) return;
      let customerInteracted = false;
      const rememberChoice = (event) => {
        if (event.isTrusted && event.target.closest('#warranty-widget')) customerInteracted = true;
      };
      root.addEventListener('pointerdown', rememberChoice, true);
      root.addEventListener('keydown', rememberChoice, true);
      const cleanup = () => {
        this.observer?.disconnect();
        root.removeEventListener('pointerdown', rememberChoice, true);
        root.removeEventListener('keydown', rememberChoice, true);
      };
      let scheduled = false;
      const initializeChoice = () => {
        const checkbox = root.querySelector('#warranty-widget input[type="checkbox"]');
        if (!checkbox || !root.querySelector('#nvd-warranty-product-input') || scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          if (this.isConnected && !customerInteracted && checkbox.checked) checkbox.click();
          cleanup();
        });
      };
      this.observer = new MutationObserver(initializeChoice);
      this.observer.observe(root, { childList: true, subtree: true });
      this.cleanup = cleanup;
      initializeChoice();
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
